var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { useFormik } from 'formik';
import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, IconButton, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import ChoiceGroup from '../FormFields/ChoiceGroup';
import ColorPicker from '../FormFields/ColorPicker';
import DatePicker from '../FormFields/DatePicker';
import FileInput from '../FormFields/FileInput';
import MultiChoiceGroup from '../FormFields/MultiChoiceGroup';
import RelatedProcess from '../FormFields/RelatedProcess';
import SwitchControl from '../FormFields/SwitchControl';
import TextField from '../FormFields/TextField';
import { get } from 'lodash';
import NewRelatedProcessField from '../FormFields/NewRelatedProcessField';
import EmbeddedRelatedProcessField from '../FormFields/EmbeddedRelatedProcessField';
import LoadingButton from '../LoadingButton';
import styled from 'styled-components';
import Autocomplete from '../FormFields/AutoComplete';
var ActionButtonsContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var labelPrefix = 'form.label';
var FieldByType = function (_a) {
    var _b = _a.field, type = _b.type, alias = _b.alias, label = _b.label, _c = _b.choiceGroupAlias, choiceGroupAlias = _c === void 0 ? '' : _c, width = _b.width, _d = _b.options, options = _d === void 0 ? [] : _d, maxInstances = _b.maxInstances, _e = _b.valueDependents, valueDependents = _e === void 0 ? {} : _e, _f = _b.required, required = _f === void 0 ? false : _f, _g = _b.regexValidation, regexValidation = _g === void 0 ? '' : _g, _h = _b.errorText, errorText = _h === void 0 ? '' : _h, onChoiceOptionSelected = _b.onChoiceOptionSelected, updateDependentValues = _b.updateDependentValues, formik = _a.formik, choiceGroups = _a.choiceGroups, config = _a.config, relatedProcessTables = _a.relatedProcessTables;
    var t = useTranslation().t;
    switch (type) {
        case 'choiceGroup':
            var choiceGroupNodes = get(choiceGroups[choiceGroupAlias], 'nodes', []);
            var choiceGroupIdAliasMap_1 = {};
            if (valueDependents) {
                choiceGroupNodes.forEach(function (node) {
                    choiceGroupIdAliasMap_1[node.id] = node.alias;
                });
            }
            return (React.createElement(Fragment, null,
                React.createElement(Grid, { item: true, xs: width },
                    React.createElement(ChoiceGroup, { label: t(labelPrefix + "." + (label || alias)), formik: formik, id: alias, required: required, options: choiceGroupNodes, onChoiceOptionSelected: onChoiceOptionSelected })),
                valueDependents &&
                    valueDependents[choiceGroupIdAliasMap_1[formik.values[alias]]] &&
                    valueDependents[choiceGroupIdAliasMap_1[formik.values[alias]]].map(function (valueDependentField) {
                        return (React.createElement(FieldByType, { field: valueDependentField, formik: formik, choiceGroups: choiceGroups, relatedProcessTables: relatedProcessTables, config: config }));
                    })));
        case 'multichoiceGroup':
            return (React.createElement(Grid, { item: true, xs: width },
                React.createElement(MultiChoiceGroup, { label: t(labelPrefix + "." + (label || alias)), formik: formik, id: alias, options: choiceGroups[choiceGroupAlias]
                        ? choiceGroups[choiceGroupAlias].nodes
                        : [], optionsLabel: 'Select multiple centers that apply' })));
        case 'textField':
            return (React.createElement(Grid, { item: true, xs: width },
                React.createElement(TextField, { label: t(labelPrefix + "." + (label || alias)), formik: formik, id: alias, required: required, regexValidation: regexValidation, errorText: errorText })));
        case 'password':
        case 'email':
            return (React.createElement(Grid, { item: true, xs: width },
                React.createElement(TextField, { type: type, label: t(labelPrefix + "." + (label || alias)), formik: formik, id: alias, required: required, regexValidation: regexValidation, errorText: errorText })));
        case 'number':
            return (React.createElement(Grid, { item: true, xs: width },
                React.createElement(TextField, { type: "number", label: t(labelPrefix + "." + (label || alias)), formik: formik, id: alias, required: required })));
        case 'datePicker':
            return (React.createElement(Grid, { item: true, xs: width },
                React.createElement(DatePicker, { label: t(labelPrefix + "." + (label || alias)), formik: formik, id: alias })));
        case 'select':
            return (React.createElement(Fragment, null,
                React.createElement(Grid, { item: true, xs: width },
                    React.createElement(ChoiceGroup, { label: t(labelPrefix + "." + (label || alias)), formik: formik, id: alias, required: required, options: options, onChoiceOptionSelected: onChoiceOptionSelected })),
                valueDependents &&
                    valueDependents[formik.values[alias]] &&
                    valueDependents[formik.values[alias]].map(function (valueDependentField) {
                        return (React.createElement(FieldByType, { field: valueDependentField, formik: formik, choiceGroups: choiceGroups, relatedProcessTables: relatedProcessTables, config: config }));
                    })));
        case 'autocomplete':
            return (React.createElement(Grid, { item: true, xs: width },
                React.createElement(Autocomplete, { label: t(labelPrefix + "." + (label || alias)), formik: formik, id: alias, required: required, options: options, updateDependentValues: updateDependentValues })));
        case 'multiselect':
            return (React.createElement(Grid, { item: true, xs: width },
                React.createElement(MultiChoiceGroup, { label: t(labelPrefix + "." + (label || alias)), formik: formik, id: alias, options: options, optionsLabel: 'Select multiple options that apply' })));
        case 'relatedProcess':
            if (config.useNewRelatedProcess) {
                return (React.createElement(Grid, { item: true, xs: width },
                    React.createElement(NewRelatedProcessField, { label: t(labelPrefix + "." + (label || alias)), formik: formik, id: alias, relatedProcess: relatedProcessTables[alias], maxInstances: maxInstances })));
            }
            else {
                return (React.createElement(Grid, { item: true, xs: width },
                    React.createElement(RelatedProcess, { label: t(labelPrefix + "." + (label || alias)), formik: formik, id: alias, relatedProcess: relatedProcessTables[alias], maxInstances: maxInstances })));
            }
        case 'embeddedRelatedProcess':
            return (React.createElement(Grid, { item: true, xs: width },
                React.createElement(EmbeddedRelatedProcessField, { label: t(labelPrefix + "." + (label || alias)), formik: formik, id: alias, relatedProcess: relatedProcessTables[alias], maxInstances: maxInstances })));
        case 'fileInput':
            return (React.createElement(Grid, { item: true, xs: width },
                React.createElement(FileInput, { formik: formik, id: alias, label: t(labelPrefix + "." + (label || alias)) })));
        case 'colorPicker':
            return (React.createElement(Grid, { item: true, xs: width },
                React.createElement(ColorPicker, { formik: formik, id: alias, label: t(labelPrefix + "." + (label || alias)) })));
    }
    return null;
};
var Field = function (_a) {
    var field = _a.field, formik = _a.formik, choiceGroups = _a.choiceGroups, config = _a.config, _b = _a.hiddenFieldConditions, hiddenFieldConditions = _b === void 0 ? {} : _b, _c = _a.relatedProcessTables, relatedProcessTables = _c === void 0 ? {} : _c;
    var t = useTranslation().t;
    var type = field.type, label = field.label, alias = field.alias, width = field.width, dependents = field.dependents, _d = field.maxInstances, maxInstances = _d === void 0 ? -1 : _d, independents = field.independents;
    if (hiddenFieldConditions[alias]) {
        return null;
    }
    if (type === 'switch') {
        return (React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Grid, { container: true, spacing: 2 },
                React.createElement(Grid, { item: true, xs: width },
                    React.createElement(SwitchControl, { label: t(labelPrefix + "." + (label || alias)), formik: formik, id: alias })),
                dependents &&
                    formik.values[alias] &&
                    dependents.map(function (dependent) {
                        return (React.createElement(FieldByType, { field: dependent, formik: formik, choiceGroups: choiceGroups, relatedProcessTables: relatedProcessTables, config: config }));
                    }),
                independents &&
                    formik.values[alias] === false &&
                    independents.map(function (independentField) {
                        return (React.createElement(FieldByType, { field: independentField, formik: formik, choiceGroups: choiceGroups, relatedProcessTables: relatedProcessTables, config: config }));
                    }))));
    }
    else if (type === 'relatedProcess') {
        if (config.useNewRelatedProcess) {
            return (React.createElement(Grid, { item: true, xs: width },
                React.createElement(NewRelatedProcessField, { label: t(labelPrefix + "." + (label || alias)), formik: formik, id: alias, relatedProcess: relatedProcessTables[alias], maxInstances: maxInstances })));
        }
        else {
            return (React.createElement(Grid, { item: true, xs: width },
                React.createElement(RelatedProcess, { label: t(labelPrefix + "." + (label || alias)), formik: formik, id: alias, relatedProcess: relatedProcessTables[alias], maxInstances: maxInstances })));
        }
    }
    return (React.createElement(FieldByType, { field: field, formik: formik, choiceGroups: choiceGroups, relatedProcessTables: relatedProcessTables }));
};
var AddProcessModelForm = function (props) {
    var t = useTranslation().t;
    var _a = React.useState(false), open = _a[0], setOpen = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(), customValidationError = _c[0], setCustomValidationError = _c[1];
    var formFields = props.formFields, _d = props.initialValues, initialValues = _d === void 0 ? {} : _d, hiddenFieldConditions = props.hiddenFieldConditions, relatedProcessTables = props.relatedProcessTables, _e = props.showRequiredLabel, showRequiredLabel = _e === void 0 ? true : _e, _f = props.config, config = _f === void 0 ? {} : _f, customValidation = props.customValidation;
    var handleClickOpen = function () {
        setOpen(true);
    };
    var handleClose = function () {
        setOpen(false);
    };
    var validate = function (values) {
        var errors = {};
        formFields.forEach(function (formField) {
            if (formField.required) {
                if (!values[formField.alias]) {
                    errors[formField.alias] = 'Required';
                }
            }
        });
        return errors;
    };
    var formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validate: validate,
        onSubmit: function (values, _a) {
            var resetForm = _a.resetForm;
            setLoading(true);
            var customValidationMessage = customValidation
                ? customValidation(values)
                : '';
            if (!customValidationMessage) {
                props.onSave(formik.values);
                setOpen(false);
                resetForm();
            }
            else {
                setCustomValidationError(customValidationMessage);
            }
            setLoading(false);
        },
    });
    console.debug('Errors', formik.errors);
    return (React.createElement("form", { onSubmit: formik.handleSubmit },
        React.createElement("span", { onClick: handleClickOpen }, props.customTrigger ? (props.customTrigger) : (React.createElement(IconButton, null,
            React.createElement(Icon, null, props.triggerIcon || 'add')))),
        React.createElement(Dialog, { fullWidth: true, maxWidth: "lg", open: open, onClose: handleClose, disableBackdropClick: true, disableEscapeKeyDown: true, scroll: 'paper', "aria-labelledby": "scroll-dialog-title", "aria-describedby": "scroll-dialog-description" },
            React.createElement(DialogTitle, { id: "scroll-dialog-title" }, props.title),
            React.createElement(DialogContent, { dividers: true },
                React.createElement(Grid, { container: true, spacing: 2 }, formFields.map(function (field, index) {
                    return (React.createElement(Field, { key: index, field: field, formik: formik, choiceGroups: props.choiceGroups, hiddenFieldConditions: hiddenFieldConditions, relatedProcessTables: relatedProcessTables, config: config }));
                }))),
            React.createElement(DialogActions, { style: { display: 'flex', justifyContent: 'space-between' } },
                showRequiredLabel && (React.createElement(Typography, { style: {
                        marginLeft: '10px',
                        fontSize: '0.9rem',
                        color: '#d32f2f',
                    } }, t('form.field.required'))),
                customValidationError && (React.createElement(Typography, { style: {
                        marginLeft: '10px',
                        fontSize: '0.9rem',
                        color: '#d32f2f',
                    } }, customValidationError)),
                React.createElement(ActionButtonsContainer, null,
                    React.createElement(Button, { onClick: handleClose, color: "primary" }, t('general.close')),
                    React.createElement(LoadingButton, { loading: loading, messageId: "general.save", disabled: Object.keys(formik.errors).length > 0, onClick: function (e) { return formik.handleSubmit(); } }))))));
};
export default AddProcessModelForm;
var templateObject_1;
//# sourceMappingURL=index.js.map